import React from "react";
import { connect } from "react-redux";

import { Marker, Popup } from "react-leaflet";
import { Box, Typography } from "@material-ui/core";
import { remCalc } from "../../utils/helpers";
import { createPinpointMarker } from "../icons/createMarker";

function PinpointDriverMarker({ pinpoint }) {
  return pinpoint.finishAddress.lat && pinpoint.finishAddress.lng ? (
    <Marker
      position={[pinpoint.finishAddress.lat, pinpoint.finishAddress.lng]}
      zIndexOffset={52500}
      icon={window.L.divIcon({
        iconSize: [40, 47],
        iconAnchor: [20, 40],
        html: `
          <div class="marker-box pinpoint-marker">
            <img style="pointer-events: none;" src="data:image/svg+xml;base64,${btoa(
              createPinpointMarker()
            )}" />
          </div>`
      })}
    >
      <Popup>
        <Box>
          <Typography variant="body2" style={{ fontWeight: 500 }}>
            Coordinates
          </Typography>

          <Typography
            variant="body2"
            color="secondary"
            style={{ fontStyle: "italic", fontSize: remCalc(12) }}
          >
            Lat: '{pinpoint.finishAddress.lat}'
          </Typography>

          <Typography
            variant="body2"
            color="secondary"
            style={{ fontStyle: "italic", fontSize: remCalc(12) }}
          >
            Lng: '{pinpoint.finishAddress.lng}'
          </Typography>
        </Box>
      </Popup>
    </Marker>
  ) : null;
}

const mapStateToProps = state => ({
  pinpoint: state.map.pinpointDriver
});

export default connect(mapStateToProps)(PinpointDriverMarker);
